import { render, staticRenderFns } from "./EventExtend.vue?vue&type=template&id=38ac7b61&scoped=true&"
import script from "./EventExtend.vue?vue&type=script&lang=js&"
export * from "./EventExtend.vue?vue&type=script&lang=js&"
import style0 from "./EventExtend.vue?vue&type=style&index=0&id=38ac7b61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac7b61",
  null
  
)

export default component.exports